export async function isImgUrl(url) {
  const img = new Image();
  img.src = url;
  return await new Promise((resolve, reject) => {
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
  });
}

export async function isValidMedia(media_url) {
  const res = await fetch(media_url, { method: 'HEAD' });
  if (res.ok == true){
    return true
  }

  return false
}  

export function getFileName(str) {
  let pathname
  try {
    pathname = new URL(str).pathname
  } catch {
    pathname = str.split('?')[0].split('#')[0]
  }
  const lastSegment = pathname.substring(pathname.lastIndexOf('/') + 1)
  try {
    return decodeURIComponent(lastSegment)
  } catch {
    return lastSegment
  }
}